import ReactGA from "react-ga4";

class AnalyticsService {

    static env = null; // Store environment once
    static isLocal = false; // Flag for local testing

    static initialize() {

        if (!this.env) {
            const hostname = window.location.hostname;

            if (hostname === "localhost") {
                this.env = "local";
                this.isLocal = true; // Set local flag
            } else if (hostname.endsWith("storybuilder.pages.dev")) {
                const subdomain = hostname.split(".")[0];
                this.env = subdomain === "storybuilder" ? 'production' : `staging`;
            } else {
                this.env = "unknown"; // Catch-all for unexpected domains
            }
        }

        if (this.isLocal) {
            console.log("🛠 Local Environment - Analytics Disabled.");
            return; // Skip GA initialization
        }

        const GA_IDS = {
            staging: "G-QXR1FP2Q0P",
            production: "G-707QGGH7VR",
        };

        const measurementId = GA_IDS[this.env] || GA_IDS.production; // Default to production if unknown

        ReactGA.initialize(measurementId, { debug: this.env === "staging" });
        console.log(`✅ GA Initialized for ${this.env} (${measurementId})`);
    }

    static trackPageView(pagePath, title) {
        if (this.isLocal) {
            console.log(`📡 (LOCAL) Pageview: ${title} (${pagePath})`);
            return;
        }

        ReactGA.send({ hitType: "pageview", page: pagePath, title }); // No need to add {env}
        console.log(`📡 GA Pageview Sent: ${title} (${pagePath})`);
    }

    static trackEvent(category, action, label = "") {
        if (this.isLocal) {
            console.log(`📊 (LOCAL) Event: ${category} - ${action} ${label ? `(${label})` : ""}`);
            return;
        }

        ReactGA.event({ category, action, label }); // No need to append {env}
        console.log(`📊 GA Event: ${category} - ${action} (${label})`);
    }
}

export default AnalyticsService;
